/**
 * Crea un servicio de sesion de juego con el adaptador de API proporcionado.
 * @param {Object} apiAdapter - Debe implementar:
 *   - getActiveGameSession(sessionType) -> Promise<data>
 *   - getUserGameSessions() -> Promise<data>
 *   - getGameSessionById(sessionId) -> Promise<data>
 *   - getGameSessionProgress(sessionId) -> Promise<data>
 *   - getGameSessionStatistics(sessionId) -> Promise<data>
 *   - closeGameSession(sessionId) -> Promise<void>
 *   - markPageAsCompleted(sessionId, pageId) -> Promise<void>
 */
function createGameSessionService(apiAdapter) {
  return {
    async getOrCreateSession(sessionType) {
      try {
        const data = await apiAdapter.getActiveGameSession(sessionType);
        return { success: true, data };
      } catch (error) {
        return {
          success: false,
          error: error.message || "Error al obtener sesión activa",
        };
      }
    },

    async getAllSessions() {
      try {
        const data = await apiAdapter.getUserGameSessions();
        return { success: true, data };
      } catch (error) {
        return {
          success: false,
          error: error.message || "Error al obtener sesiones",
        };
      }
    },

    async getSessionById(sessionId) {
      try {
        const data = await apiAdapter.getGameSessionById(sessionId);
        return { success: true, data };
      } catch (error) {
        return {
          success: false,
          error: error.message || "Error al obtener detalles de la sesión",
        };
      }
    },

    async getSessionProgress(sessionId) {
      try {
        const data = await apiAdapter.getGameSessionProgress(sessionId);
        return { success: true, data };
      } catch (error) {
        return {
          success: false,
          error: error.message || "Error al obtener progreso de la sesión",
        };
      }
    },

    async getSessionStatistics(sessionId) {
      try {
        const data = await apiAdapter.getGameSessionStatistics(sessionId);
        return { success: true, data };
      } catch (error) {
        return {
          success: false,
          error: error.message || "Error al obtener estadísticas de la sesión",
        };
      }
    },

    async closeSession(sessionId) {
      try {
        await apiAdapter.closeGameSession(sessionId);
        return { success: true };
      } catch (error) {
        return {
          success: false,
          error: error.message || "Error al cerrar la sesión",
        };
      }
    },

    async markPageAsCompleted(sessionId, pageId) {
      try {
        await apiAdapter.markPageAsCompleted(sessionId, pageId);
        return { success: true };
      } catch (error) {
        return {
          success: false,
          error: error.message || "Error al marcar página como completada",
        };
      }
    },
  };
}

module.exports = { createGameSessionService };
